import {backAdmin} from "@/lib/api/axios";

export const authorizationApi = [
    //USER




    //ADMIN
    {url: `${backAdmin}/authorization/roles`, name: 'authorization.roles', method: 'GET'},
    {url: `${backAdmin}/authorization/roles`, name: 'authorization.roles.store', method: 'POST'},
    {url: `${backAdmin}/authorization/roles/{slug}`, name: 'authorization.roles.slug', method: 'GET'},
    {url: `${backAdmin}/authorization/roles/{id}`, name: 'authorization.roles.update', method: 'PUT'},
    {url: `${backAdmin}/authorization/permissions`, name: 'authorization.permissions', method: 'GET'},
]